import {SubscriptionOptionInfoFragment} from '../../../../gql/graphql';
import {SubscriptionSettingsModel} from './SubscriptionSettings.model';

export class SubscriptionInfoModel {
  public title: string;
  public subscriptionSettings: SubscriptionSettingsModel;

  constructor(params: SubscriptionInfoModel) {
    this.title = params.title;
    this.subscriptionSettings = params.subscriptionSettings;
  }

  public static fromCheckoutV1(subscriptionInfo?: SubscriptionOptionInfoFragment | null) {
    if (!subscriptionInfo) {
      return undefined;
    }
    return new SubscriptionInfoModel({
      title: subscriptionInfo.title?.translated ?? subscriptionInfo.title?.original ?? '',
      subscriptionSettings: SubscriptionSettingsModel.fromCheckoutV1(subscriptionInfo.subscriptionSettings!),
    });
  }
}
